import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const discRoutes: CustomRouteRecordRaw = {
  path: 'disc',
  name: 'disc',
  component: EmptyLayout,
  redirect: { name: 'workbench' },
  meta: {
    title: 'DISC性格测试',
    iconfont: 'icon-user-heart-line',
    requiredPermission: 'disc'
  },
  children: [
    {
      path: 'disc-test-list',
      name: 'discTestList',
      component: () => import('@/views/disc/disc-test-list.vue'),
      meta: {
        title: '测评记录',
        requiredPermission: 'disc.test.list',
      },
    },
    {
      path: 'disc-test-report',
      name: 'discTestReport',
      component: () => import('@/views/disc/disc-test-report.vue'),
      meta: {
        title: '报告列表',
        requiredPermission: 'disc.test.report',
      },
    },
  ],
}
